export default {
  methods: {

    /**
     * Binds an API method request response to a Vue Component's data: {}
     * @param {Object}          [params={}] - configuration for the API request
     * @param {String}          params.vueDatum - string version of the Vue datum key/name
     * @param {String}          options.responseChildFieldName - the name of the child response field that contains the results (optional)
     * @param {Method}          options.requestMethod - API request method to use
     * @param {Object}          options.query - query string parameters
     */
    bindVueDataToRequestResponse(params) {
      this.loaded = false
      params.requestMethod(params.query || {})
        .then(res => {
          const response = params.responseChildFieldName === undefined ? res : res[params.responseChildFieldName]

          if (response === undefined) {
            console.warn(`Invalid data field for response params.responseChildFieldName: ${params.responseChildFieldName}`, res, params.vueDatum)
            console.warn('Response:', res)
            this[params.vueDatum] = []
            this.loaded = true
            return
          }

          this.userMessage = res.userMessage
          if (params.vueDatum !== undefined && this[params.vueDatum] !== undefined) {
            this[params.vueDatum] = response
          }

          if (params.callback !== undefined && typeof params.callback === 'function') {
            params.callback(res)
          }

          verify()
          this.loaded = true
        })
        .catch(err => {
          verify()
          this.loaded = true
          return err
        })

      let verify = () => {
        this.err = (params.vueDatum === undefined)
      }
    }
  }
}
